import React from "react";
import IField, { CARD_TYPE, CVV_TYPE } from "@cardknox/react-ifields";
import "../style/index.css";
import "@fontsource/rubik";
import { ProcessingError } from "./processing-error";
import { PaymentIcon } from "react-svg-credit-card-payment-icons";
import { FormFieldWrapper } from "./form-field-wrapper";
import { StatusIndicator } from "./status-indicator";
import Footer from "./footer";
import CryptoJS from "crypto-js";

export default class PayPage extends React.Component {
  constructor(props) {
    super(props);
    const defaultCCIfieldStyle = {
      border: "1px solid #CFCFCF",
      "font-size": "14px",
      padding: "3px",
      width: "260px",
      height: "35px",
      borderRadius: "5px",
      background: "#FFFFFF",
      paddingLeft: "15px",
    };
    const defaultCCIframeStyle = {
      border: "0",
      width: "285px",
      height: "48px",
      padding: "0px",
    };

    const defaultCVVIfieldStyle = {
      border: "1px solid #CFCFCF",
      "font-size": "14px",
      width: "40px",
      height: "40px",
      borderRadius: "5px",
      background: "#FFFFFF",
      paddingLeft: "15px",
    };

    const defaultCVVIframeStyle = {
      border: "0",
      width: "70px",
      height: "45px",
      padding: "0px",
    };

    const account = {
      xKey: localStorage.getItem("cardknoxIFieldsKey"),
      xSoftwareName: localStorage.getItem("softwareName"),
      xSoftwareVersion: localStorage.getItem("softwareVersion"),
    };

    const threeds = {
      enable3DS: false,
      waitForResponse: false,
      waitForResponseTimeout: undefined,
      amount: 10,
      month: "03",
      year: "2030",
    };
    const ccoptions = {
      placeholder: "0000 0000 0000 0000",
      enableLogging: true,
      autoFormat: true,
      autoFormatSeparator: " ",
      autoSubmit: true,
      iFieldstyle: defaultCCIfieldStyle,
      iFrameStyle: defaultCCIframeStyle,
    };
    const cvvoptions = {
      placeholder: "123",
      enableLogging: true,
      autoFormat: true,
      autoFormatSeparator: " ",
      autoSubmit: true,
      iFieldstyle: defaultCVVIfieldStyle,
      iFrameStyle: defaultCVVIframeStyle,
    };
    const isInProgressPayment = false;
    const isPaymentSuccess = false;
    const isPaymentFinished = false;

    this.state = {
      account,
      threeds,
      ccoptions,
      cvvoptions,
      issuer: "",
      isCCValid: false,
      isCCEmpty: true,
      isCVVValid: false,
      isCVVEmpty: true,
      isDateExpired: false,
      paymentRequest: {},
      authHash: "",
      isInProgressPayment,
      isPaymentSuccess,
      isPaymentFinished,
      cardType: "generic",
      organizationId: localStorage.getItem("organizationId"),
      amount: localStorage.getItem("amount"),
      currencyCode: localStorage.getItem("currency_code"),
      signature: localStorage.getItem("signature"),
      transactionId: localStorage.getItem("transactionId"),
    };
    this.cvvRef = React.createRef();
    this.ccRef = React.createRef();
    this.onPay = this.onPay.bind(this);
  }

  handleMonthChange = (event) => {
    const value = event.target.value;
    const month = Number.parseInt(value);

    if (month < 1 || month > 12) {
      this.isDateValid();
      return;
    }
    this.setState(
      {
        threeds: { ...this.state.threeds, month: event.target.value },
      },
      () => this.isDateValid()
    );
  };

  handleYearChange = (event) => {
    const value = event.target.value;
    const year = Number.parseInt(value);
    const currentYear = new Date().getUTCFullYear();

    if (year < currentYear) {
      this.isDateValid();
      return;
    }
    this.setState(
      {
        threeds: { ...this.state.threeds, year: event.target.value },
      },
      () => this.isDateValid()
    );
  };

  isCardValid() {
    return this.state.isCCValid && this.state.isCVVValid;
  }

  isCardEmpty() {
    return this.state.isCCEmpty && this.state.isCVVEmpty;
  }

  isDataValid() {
    return !this.state.isDateExpired && this.isCardValid();
  }
  isDateValid() {
    const today = new Date();
    const expDate = new Date(this.state.threeds.year, this.state.threeds.month);
    this.setState({
      isDateExpired: today.getTime() >= expDate.getTime(),
    });
  }
  render() {
    return (
      <div className="wrapper">
        <main className="wrapper-main">
          {this.state.isPaymentFinished === true && this.state.isPaymentSuccess === false ? (
            <ProcessingError />
          ) : (
            <div className="payment-card max-w-full sm:max-w-[470px] gap-4 flex-col flex sm:mt-[10vh] mt-10">
              <div className="flex justify-between items-center">
                <h1 className="text-xl font-bold ml-2 sm:ml-1">
                  Enter card details
                </h1>
                <img
                  src="/logo.png"
                  alt="Cardknox"
                  className="ml-0.5"
                  width={140}
                  height={28}
                />
              </div>
              <div className="payment-card-wrapper px-2 xs:px-9 py-6 flex flex-col gap-4 shadow-md border-0 rounded-lg">
                <div>
                  <FormFieldWrapper
                    label="Card number"
                    description="Enter the 16-digit card number on the card"
                  >
                    <div className="flex sm:gap-2 items-center">
                      <IField
                        type={CARD_TYPE}
                        account={this.state.account}
                        options={this.state.ccoptions}
                        threeDS={this.state.threeds}
                        onLoad={this.onLoad}
                        onUpdate={this.onCCUpdate}
                        onSubmit={this.onSubmit}
                        onToken={this.onToken}
                        onError={this.onError}
                        ref={this.ccRef}
                      />
                      <div className="mb-1 sm:block hidden">
                        <PaymentIcon
                          type={this.state.cardType}
                          format="flatRounded"
                          width={60}
                        />
                      </div>
                      <div className="mb-1">
                        <StatusIndicator
                          isValid={this.state.isCCValid}
                          isEmpty={this.state.isCCEmpty}
                        />
                      </div>
                    </div>
                  </FormFieldWrapper>
                </div>
                <div className="flex justify-between gap-2 sm:flex-row flex-col">
                  <FormFieldWrapper
                    label="Expiry date"
                    description="Enter the expiration date of the card"
                  >
                    <div className="flex gap-1 items-center">
                      <input
                        className={
                          this.state.isDateExpired
                            ? "h-[45px] mb-0.5 w-16 payment-card-form-expiry-date-input-not-valid"
                            : "h-[45px] mb-0.5 w-16 payment-card-form-expiry-date-input"
                        }
                        type={"number"}
                        placeholder={this.state.threeds.month || "MM"}
                        defaultValue={this.state.threeds.month}
                        onChange={this.handleMonthChange}
                      ></input>
                      <div className="text-xl">/</div>
                      <input
                        className={
                          this.state.isDateExpired
                            ? "h-[45px] mb-0.5 w-20 payment-card-form-expiry-date-input-not-valid"
                            : "h-[45px] mb-0.5 w-20 payment-card-form-expiry-date-input"
                        }
                        type={"number"}
                        placeholder={this.state.threeds.year || "YYYY"}
                        defaultValue={this.state.threeds.year}
                        onChange={this.handleYearChange}
                      ></input>
                    </div>
                  </FormFieldWrapper>
                  <FormFieldWrapper label="CVV2" description="Security code">
                    <div className="flex items-center">
                      <IField
                        type={CVV_TYPE}
                        account={this.state.account}
                        options={this.state.cvvoptions}
                        threeDS={this.state.threeds}
                        issuer={this.state.issuer}
                        onLoad={this.onLoad}
                        onUpdate={this.onCVVUpdate}
                        onSubmit={this.onSubmit}
                        onToken={this.onToken}
                        ref={this.cvvRef}
                        onError={this.onError}
                      />
                      <StatusIndicator
                        isValid={this.state.isCVVValid}
                        isEmpty={this.state.isCVVEmpty}
                      />
                    </div>
                  </FormFieldWrapper>
                </div>
              </div>
              <button
                disabled={
                  !this.isDataValid() ||
                  (this.isDataValid() && this.state.isInProgressPayment)
                }
                onClick={this.onPay}
                className={
                  !this.isDataValid()
                    ? "bg-[#a2a3a2] opacity-50 rounded-lg mx-auto my-0 w-full h-14 text-xl text-white transition-colors"
                    : this.isDataValid() && this.state.isInProgressPayment
                    ? "bg-[#3f6466] opacity-50 rounded-lg mx-auto my-0 w-full h-14 text-xl text-white transition-colors"
                    : "bg-[#1bb66e] rounded-lg mx-auto my-0 w-full h-14 text-xl text-white hover:bg-[#008346] active:bg-[#3f6466] transition-colors cursor-pointer shadow-md"
                }
              >
                {this.state.isInProgressPayment
                  ? "Processing..."
                  : !!this.state.amount
                  ? `Pay (${Number(this.state.amount).toLocaleString("en-US", {
                      style: "currency",
                      currency: this.state.currencyCode || "USD",
                    })})`
                  : "Pay"}
              </button>
            </div>
          )}
        </main>
        <Footer />
      </div>
    );
  }
  onLoad = () => {
    console.log("Iframe loaded");
  };
  onCCUpdate = (data) => {
    if (data.isValid) {
      this.setState({
        ccoptions: {
          ...this.state.ccoptions,
          iFieldstyle: { border: "1px solid green" },
        },
      });
    } else {
      this.setState({
        ccoptions: {
          ...this.state.ccoptions,
          iFieldstyle: { border: "1px solid red" },
        },
      });
    }

    if (data.isEmpty) {
      this.setState({
        ccoptions: {
          ...this.state.ccoptions,
          iFieldstyle: { border: "1px solid #CFCFCF" },
        },
      });
    }

    this.setState({
      isCCEmpty: data.isEmpty,
      isCCValid: data.isValid,
    });

    if (data.issuer) this.setState({ issuer: data.issuer });
  };
  
  onCVVUpdate = (data) => {
    if (data.isValid) {
      this.setState({
        cvvoptions: {
          ...this.state.cvvoptions,
          iFieldstyle: { border: "1px solid green" },
        },
      });
    } else {
      this.setState({
        cvvoptions: {
          ...this.state.cvvoptions,
          iFieldstyle: { border: "1px solid red" },
        },
      });
    }

    if (data.isEmpty) {
      this.setState({
        cvvoptions: {
          ...this.state.cvvoptions,
          iFieldstyle: { border: "1px solid #CFCFCF" },
        },
      });
    }

    this.setState({
      isCVVEmpty: data.isEmpty,
      isCVVValid: data.isValid,
    });

    if (data.issuer) this.setState({ issuer: data.issuer });
  };
  onSubmit = (data) => {
    console.log("IFrame submitted", data);
  };
  onToken = (data) => {
    console.log("IFrame sent token", data);
    if (data.xTokenType === "card" && data.xToken) {
      const cardTypes = [
        "visa",
        "amex",
        "discover",
        "jcb",
        "mastercard",
        "diners",
        "unknown"
      ];
      const tokenLower = data.xToken.toLowerCase();

      for (const type of cardTypes) {
        if (tokenLower.includes(type)) {
          this.setState({ cardType: type });
          break;
        }
      }
    }
  };
  onError = (data) => {
    console.error("IFrame errored", data);
  };
  getCVVToken = () => {
    this.cvvRef.current.getToken();
  };
  getCCToken = () => {
    this.ccRef.current.getToken();
  };
  onPay() {
    let createTransactionRequest = this.state.paymentRequest;
    createTransactionRequest.id = this.state.transactionId;
    createTransactionRequest.signature = this.state.signature;
    createTransactionRequest.cardNumber = this.ccRef.current.state.xToken;
    createTransactionRequest.cardType = this.state.cardType;
    createTransactionRequest.cvv = this.cvvRef.current.state.xToken;
    createTransactionRequest.cardExp = `${
      this.state.threeds.month
    }${this.state.threeds.year.slice(-2)}`;

    const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_SECRET_KEY);
    const iv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_SECRET_KEY);
    const plainText = CryptoJS.enc.Utf8.parse(
        JSON.stringify(createTransactionRequest)
    );
    const encryptedPayload = CryptoJS.AES.encrypt(plainText, key, {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ transactionPayload: encryptedPayload.toString() }),
    };
    
    this.setState({
      isInProgressPayment: true,
    });
    fetch(`v1/transaction`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        if(data) {
          this.setState({
            isInProgressPayment: false,
            isPaymentSuccess: true,
            isPaymentFinished: true,
          });
          localStorage.removeItem("transactionId");
          localStorage.removeItem("cardknoxIFieldsKey");
          localStorage.removeItem("signature");
          localStorage.removeItem("organizationId");
          localStorage.removeItem("amount");
          localStorage.removeItem("currency_code");
          localStorage.removeItem("softwareName");
          localStorage.removeItem("softwareVersion");
          window.location.href = data.redirectUrl;
        } else {
          this.setState({
            isInProgressPayment: false,
            isPaymentSuccess: false,
            isPaymentFinished: true,
          });
        }
      })
      .catch((err) => {
        console.log(err.message);
        this.setState({
          isInProgressPayment: false,
          isPaymentSuccess: false,
          isPaymentFinished: true,
        });
      });
  }
}
